import axios from 'axios';

export const fetchMainWaterTank = () => {
  return new Promise((resolve, reject) => {
    axios.get('http://water-api.sarrix.net/fetchMainWaterTank')
        .then(({data}) => {
          resolve(data)
        })
        .catch(err => {
          reject(err);
        })
  });
};

export const fetchReserveWaterTank = () => {
  return new Promise((resolve, reject) => {
    axios.get('http://water-api.sarrix.net/fetchreserveWaterTank')
        .then(({data}) => {
          resolve(data)
        })
        .catch(err => {
          reject(err);
        })
  });
};